import { Injectable } from '@angular/core';
import { ReportPrinterServiceBase } from '@skylab-shared/business';
export { ReportPrinterServiceBase };

    import { L10n, QueryBus, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@Wrapper(ReportPrinterServiceBase)
export class ReportPrinterService {
    public constructor(
        queryBus: QueryBus,
        l10n: L10n
    ) { }
}
